import { call } from '../../shared/api.ts'
import type { apiDto } from '@rs/contracts'

/**
 * ══ CỬA GỌI REST CỦA TRANG TRA CỨU CÔNG KHAI (F20) ════════════════════════════════════════════
 * ⚠ KHÔNG dùng `fetchAllPages`: cửa này trả MỘT đơn, không phải một trang danh sách. Trang công
 *   khai không có danh sách nào — đó là chủ ý, không phải thiếu sót.
 */
export type TrackView = apiDto.TrackViewDto
export type TrackPod = apiDto.TrackPodDto

const q = (tax: string, ref: string): string =>
  `tax=${encodeURIComponent(tax.trim())}&ref=${encodeURIComponent(ref.trim())}`

export const trackApi = (tax: string, ref: string): Promise<TrackView> =>
  call<TrackView>(`/api/v1/tra-cuu?${q(tax, ref)}`)

/** Địa chỉ ảnh POD — hai vế đi kèm trong chính đường dẫn, vì mã ảnh tự nó không mở được gì. */
export const podUrl = (podId: string, tax: string, ref: string): string =>
  `/api/v1/tra-cuu/anh/${podId}?${q(tax, ref)}`
